const faqsData = [
  {
    id: "1",
    question: "What is dropshipping?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

  {
    id: "2",
    question: "What is refund policy?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

  {
    id: "3",
    question: "Who are your suppliers?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

  {
    id: "4",
    question: "Why choose us?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

  {
    id: "5",
    question: "What is the shipping cost?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

  {
    id: "6",
    question: "Why dropshipping?",
    description: "Over 350,000 online businesses and entrepreneurs have used Modalyst. It's the easiest way to find the best print on demand companies"
  },

]

export default faqsData;